module.exports = __webpack_public_path__ + "static/accreditations5-70027ad57f4b883bbcd1453b2537c743.png";